export default __webpack_public_path__ + "static/media/IBimageMobilityPelvis.5019faec.png";